define('MultipleAddToCartPLP.Cell.View', [
    'multipleaddtocartplp_cell.tpl',
    'Profile.Model',
    'Store.Item.Stock.Helper',
    'SC.Configuration',
    'Backbone',
    'jQuery',
    'underscore'
], function ProductBadgesView(
    multipleAddToCartPLPTpl,
    Profile,
    StoreItemStockHelper,
    Configuration,
    Backbone,
    jQuery,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: multipleAddToCartPLPTpl,
        contextDataRequest: ['item'],
        initialize: function initialize(options) {
            var self = this;
            Backbone.Events.on('MultipleAddToCart:ClearQuantities', function selfRenderAfterClearQuantities() {
                self.render();
            });
            _.extend(this, options);
        },
        events: {
            'keyup [data-action="updateQuantity"]': 'updateQuantity',
            'change [data-action="updateQuantity"]': 'updateQuantity',
            'click [data-action="plus"]': 'addQuantity',
            'click [data-action="minus"]': 'subQuantity'
        },
        addQuantity: function addQuantity(e) {
            var $qtyField = this.$('[name="quantity"]');
            e.preventDefault();

            $qtyField.val(parseInt($qtyField.val(), 10) + 1);
            this.multipleAddToCartMainView.updateItemsQuantities(this.contextData.item().internalid, $qtyField.val());
        },
        subQuantity: function subQuantity(e) {
            var $qtyField = this.$('[name="quantity"]');
            var actualQty = parseInt($qtyField.val(), 10);
            e.preventDefault();
            if (actualQty) {
                $qtyField.val(actualQty - 1);
            }
            this.multipleAddToCartMainView.updateItemsQuantities(this.contextData.item().internalid, $qtyField.val());
        },
        updateQuantity: function updateQuantity(e) {
            var qty = jQuery(e.currentTarget).val() || 0;
            this.multipleAddToCartMainView.updateItemsQuantities(this.contextData.item().internalid, qty);
        },
        mandatoryTypes: ['GiftCert'],
        getSearchspringMandatoryitems: function getSearchsipringMandatoryItem(item) {
            return item.itemtype && _.contains(this.mandatoryTypes, item.itemtype);
        },
        getContext: function getContext() {
            var item = this.contextData.item();
            var store = Profile.getInstance().get('store');
            // eslint-disable-next-line no-underscore-dangle
            var isInStock = StoreItemStockHelper._isInStock(item, store);
            var showInput = isInStock &&
                (
                    item.itemoptions_detail && item.itemoptions_detail.fields ?
                    !_.any(item.itemoptions_detail.fields, function anyMandatory(option) { return option.ismandatory; }) :
                    !this.getSearchspringMandatoryitems(item)
                );
            return {
                showInput: showInput
            };
        }
    });
});
